<template>
  <MatchListUsComponent
    :matchList="matches"
    :sports="[sportId]"
    :sport="matches"
    :showMarketsInMatch="showMarketsInMatch"
    :showEventCode="false"
    :showTeamIcon="false"
    :showFavorites="true"
    :showStatistics="showStatistics"
    :isLiveSport="true"
    :isInLivesport="false"
    :widgetClass="'bto-sb-widget-bto-sb-widget-live'"
    v-if="isUS" />
  <div
    v-else
    :class="[
      'bto-sb-widget',
      'bto-sb-widget-prematch',
      'bto-sb-widget-overview-livenow',
      { 'bto-sb-widget-prematch-full-view': viewMode === 'multi' },
      { 'bto-sb-widget-prematch-3w': viewMode === 'single' },
      'bto-sb-widget-live-now',
    ]">
    <div class="bto-sb-widget-content">
      <empty-state
        v-if="matches.length == 0"
        :message="t('Public.NoLiveMatches')"
        :icon-class="emptyStateIcon" />
      <component
        :is="liveComp"
        :key="liveComp"
        :matches="matches"
        :isSportTreeWay="isSportTreeWay"
        :showMarketsInMatch="showMarketsInMatch"
        :markets="markets"
        :showNoMatchesMsg="showNoMatchesMsg"
        :expandedView="viewMode === 'single'"
        :isOverviewProp="true"
        :showTeamIcon="showTeamIcon"
        :showStatistics="showStatistics"
        :showFavorite="showFavorite"
        :showAll="true"
        v-show="matches.length > 0" />
    </div>
  </div>
</template>
<script>
  import { LiveWorker } from "../../../workers";
  import store from "../../../store";
  import { MARKET_TYPE_IDS } from "../../../models/enums/market-const";
  import LiveDefault from '../live-now/components/live-default';
  import LiveExpanded from '../live-now/components/live-expanded';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import MatchListUsComponent from '../../common/match-list-us-component';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';

  export default {
    name: 'LiveSport',
    components: {
      LiveDefault,
      LiveExpanded,
      EmptyState,
      MatchListUsComponent
    },
    data() {
      return {
        viewMode: APP_SETTINGS.settings.useLatam ? 'single' : 'multi',
        liveComp: APP_SETTINGS.settings.useLatam ? 'LiveExpanded' : 'LiveDefault',
        sportId: 0,
        isSportTreeWay: false,
        matches: [],
        markets: {},
        showNoMatchesMsg: false,
        emptyStateIcon: ICON_CLASS.LIVE,
        showStatistics: APP_SETTINGS.category.showStatistics,
        showFavorite: APP_SETTINGS.category.showFavorites,
        showTeamIcon: APP_SETTINGS.category.showTeamIcon,
        showMarketsInMatch: APP_SETTINGS.category.showNumberOfMarkets,
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
      };
    },
    props: {
      isCategory: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      '$route'(to) {
        if (to.params.sportId) {
          const sportId = Number.parseInt(to.params.sportId, 10)
          this.setSport(sportId);
        }
        LiveWorker.postMessage({ ev: 'lSportMatches', resp: {} });
      }
    },
    created() {
      if (!this.matches.length) {
        LiveWorker.postMessage({ ev: 'lSportMatches', resp: {} });
      }
      const sportId = Number.parseInt(this.$route.params.sportId, 10);
      if (!this.isCategory) {
        this.setSport(sportId);
      }
      this.getSportIdFromMatch();
      LiveWorker.addEventListener('message', this.handleLiveEvents);
    },
    destroyed() {
      LiveWorker.removeEventListener('message', this.handleLiveEvents);
      LiveWorker.removeEventListener('message', this.getSportIdFromMatchHandler);
    },
    methods: {
      getSportIdFromMatchHandler(msg) {
        if (msg.data.type === 'allLiveMatches') {
          const key = this.$route.params.fixtureIds ? 'tournamentId' : 'categoryId';
          const id = this.$route.params.fixtureIds ? (+this.$route.params.fixtureIds) : (+this.$route.params.categoryId);
          const match = msg.data.data.lm.find(lm => lm[key] === id);
          if (match) {
            this.setSport(match.sportId);
            LiveWorker.removeEventListener('message', this.getSportIdFromMatchHandler);
          }
        }
      },
      getSportIdFromMatch() {
        if (this.isCategory) {
          LiveWorker.addEventListener('message', this.getSportIdFromMatchHandler);
          LiveWorker.postMessage({ ev: 'allLiveMatches', resp: {} });
        }
      },
      handleLiveEvents(msg) {
        switch (msg.data.type) {
          case "matches":
            this.markets = msg.data.data.mr;
            if (this.isCategory) {
              this.filterLiveMatches(msg.data.data.lm);
            } else {
              this.matches = msg.data.data.lm;
            }
            if (!msg.data.data.lm.length) {
              this.showNoMatchesMsg = true;
            } else {
              this.showNoMatchesMsg = false;
            }
            break;
          case "matchUpdates":
            if (this.isCategory) {
              this.filterLiveMatches(msg.data.data.lm);
            } else {
              this.matches = msg.data.data.lm;
            }
        }
      },
      handleLiveEventsCategory(msg) {
        if (msg.data.type === 'allLiveMatches') {
          this.filterLiveMatches(msg.data.data.lm);
        }
      },
      filterLiveMatches(liveMatches) {
        if (this.$route.params.fixtureIds) {
          this.matches = liveMatches.filter(a => a.tournamentId === (+this.$route.params.fixtureIds));
          return;
        }
        if (this.$route.params.categoryId) {
          this.matches = liveMatches.filter(a => a.categoryId === (+this.$route.params.categoryId));
        }
      },
      /**
       * Change selected sport
       */
      setSport(sId) {
        if (typeof sId !== 'undefined' && this.sportId !== sId) {
          LiveWorker.postMessage({ ev: "setSportId", resp: sId });
          this.sportId = sId;
          this.isSportTreeWay = store.getters.getSportType(sId) === MARKET_TYPE_IDS.THREE_WAY;
        }
      },
    }
  };
</script>